import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export interface TicketFilters {
    state?: string;
    plantId?: number;
    clientId?: number;
    service?: string;
    uniqueCode?: string;
}

export interface TicketsResponse {
    tickets: any[];
    page: number;
    totalPages: number;
}

export const getSalesRepTickets = async (
    page: number,
    filters: TicketFilters = {}
): Promise<TicketsResponse> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/tickets/atc`, {
            params: {page, size: 10, ...filters},
            withCredentials: true
        });
        const transformedTickets = response.data.data.tickets.content.map((item: any) => ({
            CLIENTE: item.client,
            PLANTA: item.plant,
            SERVICIO: item.service,
            ESTADO: item.state,
            'CLAVE DE TICKET': item.uniqueCode,
        }))
        return {
            tickets: transformedTickets || [],
            page: response.data.data.tickets.number,
            totalPages: response.data.data.tickets.totalPages,
        };
    } catch (error) {
        throw error;
    }
};

export const getSalesRepFilters = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/clients/atc/filters`, {
            withCredentials: true
        });
        return {
            clients: response.data.data.filters.clients,
            services: response.data.data.filters.services,
            states: response.data.data.filters.states
        }
    } catch (error) {
        throw error;
    }
};